import styled from 'styled-components';

export const Container = styled.nav<{ isSelected: boolean }>`
  width: 100%;
  height: 52px;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.yoga.colors.primaryLight : theme.yoga.colors.white};
  cursor: pointer;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  padding-left: ${({ theme }) => theme.yoga.spacing.medium}px;

  @media screen and (max-width: 1439px) and (min-width: 1024px) {
    justify-content: center;
    padding-left: 0;
  }
`;

export const Title = styled.span<{ isSelected: boolean }>`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  font-weight: ${({ isSelected, theme }) =>
    isSelected
      ? theme.yoga.fontWeights.medium
      : theme.yoga.fontWeights.regular};
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.yoga.colors.white : theme.yoga.colors.textSecondary};

  @media screen and (max-width: 1439px) and (min-width: 1024px) {
    display: none;
  }
`;
